import { EffiePatternWrapper } from "@components/styles"
import { styled, theme } from "@theme/stitches.config"

export const StyledEffiePatternWrapper = styled(EffiePatternWrapper, {
    zIndex: 1,
    width: "auto",
    top: -290,
    left: 330,
    "@smDown": {
        top: 60,
        left: 820
    },
    "& svg": {
        height: 875,
        "@smDown": {
            height: 165
        }
    }
})

export const Content = styled("div", {
    maxWidth: 600,
    height: "100%",
    ml: 80,
    width: "100%",
    zIndex: 2,
    "@lgDown": {
        width: "60%",
        m: "auto"
    },
    "@smDown": {
        width: "90%",
        textAlign: "center"
    }
})

export const ContentCardWrapper = styled("div", {
    position: "relative",
    backgroundColor: theme.colors.effieGold,
    borderRadius: 6,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    py: 100,
    height: "100%",
    h2: {
        color: theme.colors.N0
    },
    "& p": {
        color: theme.colors.N0,
        opacity: 1
    },
    variants: {
        size: {
            small: {
                maxWidth: 680,
                width: "100%",
                [`${Content}`]: {
                    maxWidth: 480
                },
                [`${StyledEffiePatternWrapper}`]: {
                    top: -170,
                    left: 90
                },
                "@smDown": {
                    borderRadius: 0,
                    width: "100vw",
                    left: "50%",
                    right: "50%",
                    marginLeft: "-50vw",
                    marginRight: "-50vw"
                }
            },
            full: {
                maxHeight: 544,
                "@smDown": {
                    borderRadius: 0,
                    width: "100vw",
                    left: "50%",
                    right: "50%",
                    marginLeft: "-50vw",
                    marginRight: "-50vw"
                }
            }
        }
    }
})
